import { Chip } from "@mui/material";
import { useState } from "react";

import type { ChipProps } from "@mui/material";
import type { FC } from "react";

export const HoverChip: FC<
  ChipProps & { hoverProps?: ChipProps } & { defaultProps?: ChipProps }
> = ({ defaultProps, hoverProps, ...props }) => {
  const [hover, setHover] = useState(false);

  const usedProps = hover ? hoverProps : defaultProps;

  return (
    <Chip
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      {...props}
      {...usedProps}
      sx={[
        ...(Array.isArray(props.sx) ? props.sx : [props.sx]),
        ...(Array.isArray(usedProps?.sx) ? usedProps.sx : [usedProps?.sx]),
        { cursor: "pointer" },
      ]}
    />
  );
};
